import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BookingStepService } from '../services/booking-step.service';
import { BookingStepEnum } from '../models/booking-step.enum';
import { map } from 'rxjs/operators';
import { OrderStateService } from '../../order/services/order-state.service';
import { BookingProductStepService } from '../services/booking-product-step.service';

@Injectable({
  providedIn: 'root'
})
export class BookingProductAuthnGuard implements CanActivate {

  constructor(
    private router: Router,
    private bookingProductStepService: BookingProductStepService,
  ) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.bookingProductStepService.isBookingProductAuthAvailable) {
      return true;
    }

    this.router.navigate(['/booking/products']);
    return false;
  }
}
